import React from "react";
import { ExperimentContext } from "./ExperimentProvider";
import type { ExperimentContextType } from "./ExperimentProvider";

export const useExperimentContext = (): ExperimentContextType =>
  React.useContext(ExperimentContext);
